import { render } from "./Inner.vue?vue&type=template&id=31388a46"
import script from "./Inner.vue?vue&type=script&lang=js"
export * from "./Inner.vue?vue&type=script&lang=js"
script.render = render

export default script